import { useSortable } from '@dnd-kit/sortable';
import ErrorMessage from '../error-message/error-message';
import cloneDeep from 'lodash.clonedeep';
import { CSS } from '@dnd-kit/utilities';
import { useTranslation } from 'react-i18next';

export interface QuestionOptionItemsProps {
  values: any;
  optionId: string;
  optionIndex: number;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  pageIndex: number;
  questionIndex: number;
  question: any;
  errors: any;
  touched: any;
}

const QuestionOptionsItems = ({
  values,
  optionId,
  optionIndex,
  setFieldValue,
  pageIndex,
  questionIndex,
  question,
  errors,
  touched,
}: QuestionOptionItemsProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: optionId });
  const { t } = useTranslation(['common']);

  const removeOption = (
    pageIndex: number,
    questionIndex: number,
    optionIndex: number
  ) => {
    const newPages = cloneDeep(values.pages);
    newPages[pageIndex].questions[questionIndex].options?.splice(
      optionIndex,
      1
    );
    setFieldValue('pages', newPages);
  };

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div className="relative flex flex-col col-span-2 mb-5">
        <label
          htmlFor={`pages[${pageIndex}].questions[${questionIndex}].options[${optionIndex}]`}
          className="text-sm font-medium text-gray-700"
        >
          {t('option-with-number', {
            optionNumber: optionIndex + 1,
          })}
        </label>
        <div className="relative">
          <span
            className="absolute top-1/2 left-0 transform -translate-x-6 -translate-y-1/2"
            {...listeners}
            {...attributes}
          >
            <i className="fas fa-grip-dots-vertical text-gray-400 text-lg cursor-pointer" />
          </span>
          <input
            type="text"
            name={`pages[${pageIndex}].questions[${questionIndex}].options[${optionIndex}]`}
            id={`pages[${pageIndex}].questions[${questionIndex}].options[${optionIndex}]`}
            placeholder="Option"
            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-dark-primaryBackground dark:text-gray-200"
            value={question?.options[optionIndex].label}
            onChange={(e) => {
              setFieldValue(
                `pages[${pageIndex}].questions[${questionIndex}].options[${optionIndex}].label`,
                e.target.value,
                true
              );
            }}
          />
        </div>
        <ErrorMessage
          errors={errors?.pages?.[pageIndex]?.questions?.[questionIndex]?.type}
          touched={touched.pages}
        />
        {question?.options.length > 2 && (
          <button
            type="button"
            onClick={() => {
              removeOption(pageIndex, questionIndex, optionIndex);
            }}
          >
            <i className="fa-solid fa-circle-xmark text-red-500 text-lg absolute top-[11px] -right-[11px] cursor-pointer" />
          </button>
        )}
      </div>
    </div>
  );
};

export { QuestionOptionsItems };
